import config from "../../../config"
import axiosInstance from "../../axiosInstance"

const get_provinces = async () => {
    const code = "ARG"
    const response = await axiosInstance.get(`https://app-dev.sysone.com/location/v1/countries/${code}/provinces`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
}

const get_cities = async (provinceCode) => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/location/v1/provinces/${provinceCode}/cities`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
}

const get_postal_codes = async (cityCode) => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/location/v1/cities/${cityCode}/postal-codes`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
}

const get_identification_types = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/party/v1/identification-types`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
            params: {
                "party-type-code": "INDIVIDUAL",
                "country-code": "ARG"
            }
        })
    return response.data
}

const get_genders = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/party/v1/genders`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
}


const get_marital_statuses = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/party/v1/marital-statuses`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
}

const get_credit_card_types = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/finance/v1/credit-card-types`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
};

const get_credit_card_providers = async () => {
    return {
        "values": [
            {
                "name": "Visa",
                "code": "VISA"
            },
            {
                "name": "Master card",
                "code": "MASTER"
            },
            {
                "name": "American Express",
                "code": "AMEX"
            },
            {
                "name": "Tarjeta Naranja",
                "code": "NARANJA"
            },
            {
                "name": "Cabal",
                "code": "CABAL"
            },
            {
                "name": "Tarjeta Nevada",
                "code": "NEVADA"
            }
        ]
    };
};

const get_currencies = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/finance/v1/currencies`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
};

const get_banks = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/finance/v1/banks`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
};

const get_bank_branches = async (code) => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/finance/v1/banks/${code}/branches`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
};

const get_bank_account_types = async () => {
    const response = await axiosInstance.get(`https://app-dev.sysone.com/finance/v1/bank-account-types`,
        {
            headers: {
                "X-user": "sysone",
                "X-tenant": "sysone",
                "X-Api-Key": config.sysone.API_KEY_TENANT,
            },
        })
    return response.data
};

export {
    get_provinces,
    get_cities,
    get_postal_codes,
    get_identification_types,
    get_genders,
    get_marital_statuses,
    get_credit_card_types,
    get_credit_card_providers,
    get_currencies,
    get_banks,
    get_bank_branches,
    get_bank_account_types
}
